import { render, staticRenderFns } from "./flow-navigation.vue?vue&type=template&id=3852f3fd&scoped=true&"
import script from "./flow-navigation.vue?vue&type=script&lang=ts&"
export * from "./flow-navigation.vue?vue&type=script&lang=ts&"
import style0 from "./flow-navigation.vue?vue&type=style&index=0&id=3852f3fd&lang=scss&scoped=true&"
import style1 from "./flow-navigation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3852f3fd",
  null
  
)

export default component.exports